"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const SingleReferenceHandler_1 = require("./SingleReferenceHandler");
const Element_1 = require("../../tree/Element");
const Texture_1 = require("../../tree/Texture");
const TextHandler_1 = require("./TextHandler");
const ChildrenHandler_1 = require("./ChildrenHandler");
const ShaderHandler_1 = require("./ShaderHandler");
exports.handlers = [
    new SingleReferenceHandler_1.SingleReferenceHandler(Element_1.Element, "texture", Texture_1.Texture, (obj) => [obj.stage]),
    new ShaderHandler_1.ShaderHandler(Element_1.Element, "shader"),
    new TextHandler_1.TextHandler(Element_1.Element, "text"),
    new ChildrenHandler_1.ChildrenHandler(Element_1.Element, "children"),
];
//# sourceMappingURL=handlers.js.map